export { SpaLandingPageConnected as SpaLandingPage } from './container';
export { SpaLandingPageVersion } from './SpaLandingPageVersion';
